/* Nuuke — comportements des sections tw-* (idempotent : chaque bloc s'initialise une seule fois,
   et se ré-initialise quand l'éditeur de thème recharge une section). */
(() => {
  // 18/09 : tous les formats monétaires Shopify (l'EUR affichait « €{{amount_with_comma_separator}} »)
  const MONEY_KEYS = {
    amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'], amount_no_decimals_with_space_separator: [0, ' ', ''],
    amount_with_space_separator: [2, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.']
  };
  const money = (cents, fmt) => {
    const f = fmt || '${{amount}}';
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    const [dec, th, dp] = MONEY_KEYS[m ? m[1] : 'amount'] || MONEY_KEYS.amount;
    const [i, d] = (cents / 100).toFixed(dec).split('.');
    return f.replace(/\{\{\s*\w+\s*\}\}/, i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? dp + d : ''));
  };

  // 27/10 — cadeau du pack 6+ (mêmes valeurs que assets/tw-gift.js, qui reste le référentiel et le filet).
  const GIFT_TANKS = [8263635468397, 15399255900269, 10307301343341, 8266795516013, 15367947223149, 15367771258989, 15373752303725, 15373758201965];
  const GIFT_VARIANT = 45906528927853; // 🎁 Free Mystery Gift — « Mystery surprise » (NK-WASH-1PK, 0 $)
  const GIFT_ALL = [45906528895085, 45906528927853, 45906528960621, 50505847144557, 50505847177325, 50505847210093, 67865478332525]; // tous les cadeaux reconnus par tw-gift.js (US, FR, sac Bubble)
  const MARCHE_FR_GIFT = () => {
    const r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return /^\/fr-(fr|ch)(\/|$)/.test(r) || !!(window.Shopify && Shopify.currency && /^(EUR|CHF)$/.test(Shopify.currency.active || ''));
  };

  function initGallery(root) {
    const main = root.querySelector('.tw-gal-main img');
    const rail = root.querySelector('[data-tw-rail]');
    const isPhone = () => matchMedia('(max-width: 979px)').matches;

    root.querySelectorAll('[data-tw-thumb]').forEach(b => b.addEventListener('click', () => {
      root.querySelectorAll('[data-tw-thumb]').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      // Mobile : la photo vit dans le rail, on s'y déplace. Ordinateur : on remplace la 1re diapo.
      const i = +b.dataset.i || 0;
      if (isPhone() && rail && rail.children[i]) {
        rail.scrollTo({ left: rail.children[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      } else if (main) { main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; }
    }));

    // Flèche « photo suivante » du rail (mobile).
    const next = root.querySelector('[data-tw-gal-next]');
    next && next.addEventListener('click', () => {
      if (!rail) return;
      const w = rail.firstElementChild ? rail.firstElementChild.offsetWidth + 8 : rail.clientWidth;
      const end = rail.scrollWidth - rail.clientWidth - 4;
      rail.scrollTo({ left: rail.scrollLeft >= end ? 0 : rail.scrollLeft + w, behavior: 'smooth' });
    });

    // Flèches ↑ ↓ de la colonne de vignettes (ordinateur) + état désactivé aux extrémités.
    const strip = root.querySelector('[data-tw-thumbs]');
    const arrows = [...root.querySelectorAll('[data-tw-thumbs-scroll]')];
    if (strip && arrows.length) {
      const syncArrows = () => {
        const max = strip.scrollHeight - strip.clientHeight - 2;
        arrows.forEach(a => {
          const dir = +a.dataset.twThumbsScroll;
          a.disabled = max <= 0 || (dir < 0 ? strip.scrollTop <= 2 : strip.scrollTop >= max);
        });
      };
      arrows.forEach(a => a.addEventListener('click', () => {
        strip.scrollBy({ top: (+a.dataset.twThumbsScroll) * 180, behavior: 'smooth' });
        setTimeout(syncArrows, 400);
      }));
      strip.addEventListener('scroll', syncArrows, { passive: true });
      syncArrows();
      addEventListener('resize', syncArrows, { passive: true });
    }

    // Le rail suit la vignette active quand on swipe (mobile).
    if (rail) rail.addEventListener('scroll', () => {
      if (!isPhone()) return;
      const i = Math.round(rail.scrollLeft / ((rail.firstElementChild ? rail.firstElementChild.offsetWidth : rail.clientWidth) + 8));
      root.querySelectorAll('[data-tw-thumb]').forEach(x => x.classList.toggle('on', (+x.dataset.i || 0) === i));
    }, { passive: true });
  }

  function initBuybox(root) {
    const dataEl = root.querySelector('[data-tw-product]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const fmt = root.dataset.moneyFormat;
    const opts = product.options || [];
    const bundles = [...root.querySelectorAll('[data-tw-bundle]')];
    const defaults = (root.dataset.defaultSize || '').trim();
    // Loom Matteo 18/09 : taille appliquée à tout le pack (listes déroulantes, comme Maggie's), garde-fous « sold out ».
    const optName = o => typeof o === 'string' ? o : o.name;
    const colorIdx = opts.findIndex(o => /colou?r|couleur/i.test(optName(o)));
    const sizeIdx0 = opts.length > 1 ? opts.findIndex((o, i) => i !== colorIdx && /size|taille/i.test(optName(o))) : -1;
    const sizeIdx = sizeIdx0 > -1 || opts.length < 2 ? sizeIdx0 : opts.findIndex((o, i) => i !== colorIdx);
    // 29/10 (Matteo, carte 1219948092747075) : « (New) » à côté des nouvelles couleurs, tanks US seulement (valeur d'option inchangée).
    const NEWC = [8263635468397, 8275210764397, 15367947223149, 15399255670893, 15399255900269].indexOf(product.id) > -1 ? ['Light Blue', 'Cream', 'Camel', 'Dusty Rose'] : [];
    const findVariant = values => product.variants.find(v => values.every((val, i) => v.options[i] === val));
    const rowVals = row => [...row.querySelectorAll('select')].map(s => s.value);
    const okVar = (row, oi, val) => { const x = findVariant([...row.querySelectorAll('select')].map(s => +s.dataset.opt === oi ? val : s.value)); return !!(x && x.available !== false); };
    const syncRow = row => {
      row.querySelectorAll('select').forEach(sel => { const oi = +sel.dataset.opt; [...sel.options].forEach(o => { o.textContent = o.value + (oi === colorIdx && NEWC.indexOf(o.value) > -1 ? ' (New)' : '') + (okVar(row, oi, o.value) ? '' : (root.dataset.soldOutSuffix || ' – sold out')); }); });
    };
    // Combinaison indisponible : on garde la couleur et on prend la taille disponible la plus proche (la plus grande en cas d'égalité).
    const fixRow = row => {
      const v = findVariant(rowVals(row)); if (v && v.available !== false) return;
      const ss = sizeIdx > -1 && row.querySelector(`select[data-opt="${sizeIdx}"]`); if (!ss) return;
      const cur = ss.selectedIndex;
      const alt = [...ss.options].map((o, i) => ({ i, v: o.value })).filter(o => okVar(row, sizeIdx, o.v)).sort((a, b) => Math.abs(a.i - cur) - Math.abs(b.i - cur) || b.i - a.i)[0];
      console.warn('[tw-buybox] unavailable:', rowVals(row).join(' / '), alt ? '→ ' + alt.v : '(no size available in this color)');
      if (alt) ss.value = alt.v;
    };
    const sized = (src, w) => src ? src.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '') + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
    const imgFor = color => { const v = product.variants.find(x => x.options[colorIdx] === color && x.featured_image); return v ? v.featured_image.src : ''; };
    const cutouts = {}; (root.dataset.twCutouts || '').split(';').forEach(p => { const k = p.indexOf('|'); if (k > 0) cutouts[p.slice(0, k)] = p.slice(k + 1); });
    const cutFor = color => cutouts[color] || imgFor(color);
    // Pastilles : teintes relevées sur les photos détourées des tanks.
    const DOTS = { 'Jet Black': '#1E1C1D', 'Sand': '#D8B49B', 'Cocoa': '#65514B', 'Ivory': '#C1ADA2', 'Wine Red': '#6D1F27', 'Blush': '#E8BFB5', 'Midnight': '#1F2433', 'Pearl': '#F1ECE4', 'Mist': '#A9AAAD', 'Onyx': '#1E1C1D', 'Soft Nude': '#D8B49B', 'Espresso': '#4A3328', 'Heather': '#9A9A9E', 'Mocha': '#6B4A3A', 'Nude': '#D8B49B', 'Black': '#1E1C1D', 'Red': '#8A2229', 'Dusty Rose': '#C28E88', 'Grey': '#8E8E93', 'Olive': '#6B5F3E', 'Teal': '#34585E', 'White': '#F6F3EE', 'Camel': '#B28669', 'Cream': '#E0D8CA', 'Light Blue': '#C5D4DA',
      // Produit FR (tank-fr) : mêmes couleurs, noms français.
      'Moka': '#6B4A3A', 'Noir': '#1E1C1D', 'Rouge': '#8A2229', 'Vieux rose': '#C28E88', 'Gris': '#8E8E93', 'Bleu canard': '#34585E', 'Blanc': '#F6F3EE' };
    const paintRow = row => {
      const s = colorIdx > -1 && row.querySelector(`select[data-opt="${colorIdx}"]`); if (!s) return;
      const dot = row.querySelector('.tw-cdot'); if (dot) dot.style.background = DOTS[s.value] || '#D8B49B';
      const img = row.querySelector('.tw-unit-img'); const src = cutFor(s.value);
      if (img && src) { img.src = sized(src, 160); img.alt = s.value; }
    };
    // Construit les lignes « [photo] [couleur] [taille] » pour chaque bundle.
    bundles.forEach(b => {
      const units = b.querySelector('[data-tw-units]');
      const qty = +b.dataset.qty || 1;
      const label = b.dataset.unitLabel || 'Item';
      units.style.setProperty('--opts', opts.length || 1);
      for (let i = 0; i < qty; i++) {
        const row = document.createElement('div');
        row.className = 'tw-unit' + (NEWC.length ? ' tw-unit--new' : '');
        // Loom Matteo 18/09 (2:21) + Samuel : comme Maggie's, photo du tank dans sa couleur + pastille dans la liste, sans « Tank N ».
        row.innerHTML = colorIdx > -1 ? '<img class="tw-unit-img" alt="" loading="lazy">' : `<span>${label} ${i + 1}</span>`;
        opts.forEach((o, oi) => {
          const name = typeof o === 'string' ? o : o.name;
          let values = typeof o === 'string' ? [...new Set(product.variants.map(v => v.options[oi]))] : o.values;
          // 27/10 (Samuel, switch fournisseur) : sur les tanks US, une couleur dont AUCUNE variante n'est disponible (Grey) n'est plus proposée. FR non concerné.
          if (oi === colorIdx && [8263635468397, 8275210764397, 15367947223149, 15399255670893, 15399255900269].indexOf(product.id) > -1) { const ok = values.filter(val => product.variants.some(x => x.options[oi] === val && x.available !== false)); if (ok.length) values = ok; }
          const sel = document.createElement('select');
          sel.setAttribute('aria-label', `${name}, ${label} ${i + 1}`);
          sel.dataset.opt = oi;
          values.forEach(v => sel.add(new Option(v, v)));
          // 1re option (couleur) : on alterne pour montrer le choix ; les autres : taille par défaut si elle existe.
          if (oi === 0 && opts.length > 1) sel.value = values[i % values.length];
          else if (defaults && values.includes(defaults)) sel.value = defaults;
          if (oi === colorIdx) {
            const wrap = document.createElement('span');
            wrap.className = 'tw-csel';
            wrap.innerHTML = '<i class="tw-cdot" aria-hidden="true"></i>';
            wrap.appendChild(sel);
            row.appendChild(wrap);
          } else row.appendChild(sel);
        });
        paintRow(row);
        fixRow(row); syncRow(row);
        units.appendChild(row);
      }
      if (root.dataset.sizeUnitsLabel && opts.length > 1) {
        const sl = document.createElement('button');
        sl.type = 'button'; sl.className = 'tw-units-size'; sl.dataset.twSizeOpen = ''; sl.textContent = root.dataset.sizeUnitsLabel;
        // 15/09 : ouvre la fenêtre directement (le clic ne remonte pas jusqu'à root : .tw-units bloque la propagation)
        sl.addEventListener('click', e => { e.preventDefault(); const d = root.querySelector('[data-tw-size-dlg]'); if (d) { d.showModal ? d.showModal() : d.setAttribute('open', ''); } });
        units.appendChild(sl);
      }
      units.addEventListener('click', e => e.stopPropagation());
      if (qty === 1 && opts.length === 0) units.remove();
    });

    // Aperçu du pack : la grande photo montre exactement la sélection (1 tank = packshot de sa couleur,
    // 3 ou 6 tanks = grille des packshots dans les couleurs choisies), mis à jour en direct.
    const gal = root.querySelector('.tw-gal-main');
    const mainImg = gal && gal.querySelector('img');
    const unitColors = b => [...b.querySelectorAll('.tw-unit')].map(r => { const s = r.querySelector(`select[data-opt="${colorIdx}"]`); return s ? s.value : null; }).filter(Boolean);
    let pack = null;
    // Galerie dédiée (data-tw-fixed-gal, ex. LP Mastectomie) : pas d'aperçu du pack ni de changement de photo par couleur.
    if (gal && colorIdx > -1 && !root.hasAttribute('data-tw-fixed-gal')) {
      pack = document.createElement('div');
      pack.className = 'tw-pack'; pack.hidden = true; pack.setAttribute('aria-live', 'polite');
      gal.appendChild(pack);
    }
    const minis = b => {
      let m = b.querySelector('.tw-bnd-minis');
      if (!m) { m = document.createElement('span'); m.className = 'tw-bnd-minis'; m.setAttribute('aria-hidden', 'true'); const t = b.querySelector('.tw-bnd-t'); t && t.parentNode.insertBefore(m, t); }
      m.innerHTML = unitColors(b).map(c => `<img src="${sized(cutFor(c), 160)}" alt="" loading="lazy">`).join('');
    };
    const renderPack = b => {
      if (!pack || !b) return;
      const colors = unitColors(b);
      if (colors.length <= 1) {
        pack.hidden = true; gal.classList.remove('is-pack');
        const src = imgFor(colors[0]);
        if (src && mainImg) { mainImg.srcset = ''; mainImg.src = sized(src, 1400); }
      } else {
        // Disposition façon bundles BoxHero : détourés qui se chevauchent en léger diagonale, 2 rangées dès 4 tanks.
        // La largeur se déduit du nombre de tanks pour que la rangée la plus chargée tienne
        // TOUJOURS dans le cadre (le pack de 7 débordait des deux côtés et se faisait rogner).
        const n = colors.length, rows = n <= 4 ? 1 : 2, per = Math.ceil(n / rows);
        const SPAN = 92, OVERLAP = 0.55;
        const w = Math.min(54, SPAN / (1 + OVERLAP * (per - 1)));
        const step = w * OVERLAP;
        let html = '';
        colors.forEach((c, i) => {
          const r = rows === 2 ? (i < per ? 0 : 1) : 1, k = rows === 2 && r === 1 ? i - per : i;
          const cnt = rows === 2 ? (r === 0 ? per : n - per) : n;
          const left = (100 - (w + step * (cnt - 1))) / 2 + k * step;
          const top = rows === 1 ? 24 + k * 4 : (r === 0 ? 6 + k * 3 : 34 + k * 3);
          const sc = rows === 2 && r === 0 ? 0.92 : 1;
          html += `<img src="${sized(cutFor(c), 700)}" alt="Tank ${i + 1}: ${c}" style="left:${left}%;top:${top}%;width:${w}%;z-index:${r * 10 + k + 1};transform:perspective(900px) rotateY(-12deg) scale(${sc})">`;
        });
        pack.className = 'tw-pack tw-pack--stack';
        pack.innerHTML = html + '<i class="tw-pack-floor" aria-hidden="true"></i>';
        pack.hidden = false; gal.classList.add('is-pack');
      }
      root.querySelectorAll('[data-tw-thumb]').forEach(x => x.classList.remove('on'));
    };
    // Taille : le 1er changement de taille (ligne « meneuse ») s'applique à tous les tanks de tous les packs,
    // sauf aux lignes que la cliente a déjà réglées elle-même ; ensuite chaque tank reste modifiable un par un.
    // 18/09 (Samuel) : même règle pour la couleur — le 1er changement de couleur passe tous les tanks dans cette couleur,
    // ensuite chaque tank se change seul. Meneuse et « déjà réglé » sont suivis séparément pour la taille et la couleur.
    const leaders = {};
    root.addEventListener('change', e => {
      const s = e.target;
      if (!s.matches('.tw-unit select')) return;
      const row = s.closest('.tw-unit');
      const oi = +s.dataset.opt;
      if (oi === sizeIdx || oi === colorIdx) {
        if (!leaders[oi]) leaders[oi] = row;
        if (row === leaders[oi]) {
          root.querySelectorAll('.tw-unit').forEach(r => {
            if (r === row || r.dataset['own' + oi]) return;
            const t = r.querySelector(`select[data-opt="${oi}"]`);
            if (t && [...t.options].some(o => o.value === s.value)) { t.value = s.value; fixRow(r); syncRow(r); paintRow(r); }
          });
          if (oi === colorIdx) bundles.forEach(b => { minis(b); if (b.classList.contains('on')) renderPack(b); });
        } else row.dataset['own' + oi] = '1';
      }
      fixRow(row); syncRow(row); paintRow(row);
      const err = root.querySelector('[data-tw-err]'); if (err) err.hidden = true;
    });
    if (colorIdx > -1) {
      root.addEventListener('change', e => {
        const s = e.target;
        if (!s.matches('.tw-unit select') || +s.dataset.opt !== colorIdx) return;
        const b = s.closest('[data-tw-bundle]');
        minis(b);
        if (b.classList.contains('on')) renderPack(b);
      });
      // Une vignette de la galerie reste cliquable : elle masque l'aperçu du pack.
      root.querySelectorAll('[data-tw-thumb]').forEach(t => t.addEventListener('click', () => { if (pack) { pack.hidden = true; gal.classList.remove('is-pack'); } }));
      bundles.forEach(minis);
    }

    const sizeDlg = root.querySelector('[data-tw-size-dlg]');
    root.addEventListener('click', e => {
      const o = e.target.closest('[data-tw-size-open]');
      if (!o || !sizeDlg) return;
      e.preventDefault(); e.stopPropagation();
      sizeDlg.showModal ? sizeDlg.showModal() : sizeDlg.setAttribute('open', '');
    });
    sizeDlg && sizeDlg.addEventListener('click', e => { if (e.target === sizeDlg) sizeDlg.close(); });
    // Liens e-mail « check the size guide » (…#tw-size) : ouvre la fenêtre des tailles (une seule fois par page,
    // même si tw.js s'initialise sur plusieurs root).
    if (sizeDlg && !window.__twSizeHash) {
      window.__twSizeHash = true;
      const openSizeFromHash = () => {
        if (location.hash !== '#tw-size' || document.getElementById('tw-size') || sizeDlg.open) return;
        sizeDlg.showModal ? sizeDlg.showModal() : sizeDlg.setAttribute('open', '');
      };
      openSizeFromHash();
      window.addEventListener('hashchange', openSizeFromHash);
    }

    const priceEls = root.querySelectorAll('[data-tw-price]');
    const cmpEl = root.querySelector('[data-tw-compare]');
    const saveEl = root.querySelector('[data-tw-save]');
    const stickyLabel = root.querySelector('[data-tw-sticky-label]');
    // 16/09 (Samuel) : à l'arrivée on laisse la VRAIE photo produit ; l'aperçu du pack n'apparaît
    // que si la cliente touche à quelque chose (choix d'un palier ou d'une couleur).
    const pick = (b, initial) => {
      bundles.forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-checked', x === b); });
      priceEls.forEach(el => el.textContent = money(+b.dataset.total, fmt));
      if (cmpEl) { cmpEl.textContent = money(+b.dataset.compare, fmt); cmpEl.hidden = !(+b.dataset.compare > +b.dataset.total); }
      if (saveEl) { const st = b.dataset.saveBadge || b.dataset.save || ''; (saveEl.querySelector('[data-tw-save-txt]') || saveEl).textContent = st; saveEl.hidden = !st; } // 27/09 : libellé du badge prix séparé (« Save $X with Fall Sale »)
      const eachEl = root.querySelector('[data-tw-each]');
      if (eachEl) { const q = +b.dataset.qty || 1; eachEl.hidden = q < 2; eachEl.textContent = q < 2 ? '' : `= ${money(+b.dataset.each, fmt)}${eachEl.dataset.suffix || '/tank'}`; }
      if (stickyLabel) stickyLabel.textContent = `${b.dataset.title}\u00a0·\u00a0${money(+b.dataset.total, fmt)}`; // 15/09 : jamais le point seul en début de ligne
      if (!initial) renderPack(b);
      const ul = root.querySelector('[data-tw-unlock]');
      if (ul) { const min = +ul.dataset.min || 3, q = +b.dataset.qty || 1, ok = q >= min;
        ul.textContent = (ok ? ul.dataset.high : ul.dataset.low).replace('[left]', Math.max(min - q, 0)); ul.classList.toggle('is-on', ok); ul.hidden = !ul.textContent; }
    };
    bundles.forEach(b => b.addEventListener('click', () => pick(b)));
    bundles.forEach(b => b.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(b); } }));
    pick(root.querySelector('[data-tw-bundle].on') || bundles[0], true);

    const atc = root.querySelector('[data-tw-atc]');
    const err = root.querySelector('[data-tw-err]');
    atc && atc.addEventListener('click', async e => {
      e.preventDefault();
      const b = root.querySelector('[data-tw-bundle].on') || bundles[0];
      const counts = new Map();
      let missing = false;
      if (opts.length === 0 || (opts.length === 1 && product.variants.length === 1)) {
        counts.set(product.variants[0].id, +b.dataset.qty || 1);
      } else {
        b.querySelectorAll('.tw-unit').forEach((row, ri) => {
          fixRow(row); syncRow(row);
          const vals = rowVals(row);
          const v = findVariant(vals);
          if (!v || v.available === false) { missing = (missing || []).concat(`${b.dataset.unitLabel || 'Item'} ${ri + 1} (${vals.join(' / ')})`); console.warn('[tw-buybox] sold out or missing variant:', vals, v); return; }
          counts.set(v.id, (counts.get(v.id) || 0) + 1);
        });
      }
      if (missing) { if (err) { err.hidden = false; err.textContent = Array.isArray(missing) ? (root.dataset.soldOutTpl ? root.dataset.soldOutTpl.replace('{items}', missing.join(', ')).replace('{tank}', missing.length > 1 ? (root.dataset.soldOutMany || '') : (root.dataset.soldOutOne || '')) : `Sold out: ${missing.join(', ')}. Please pick another color or size for ${missing.length > 1 ? 'these tanks' : 'this tank'}.`) : (root.dataset.soldOut || root.dataset.unavailable || 'One of your choices is unavailable.'); } return; }
      atc.setAttribute('disabled', '');
      try {
        const items = [...counts].map(([id, quantity]) => ({ id, quantity, properties: { _bundle: b.dataset.title } }));
        const rt = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        let giftLine = null; // 27/10 : cadeau du pack 6+ ajouté dans le même appel (voir plus bas)

        // Tiroir du panier (Horizon) quand il est disponible ; sinon, ancien comportement : /cart.
        const CartEvt = window.__twCartEvent;
        const drawer = document.querySelector('cart-drawer-component');
        const sectionIds = [...document.querySelectorAll('cart-items-component')].map(c => c.dataset.sectionId).filter(Boolean);
        // 18/09 : AMP Slide Cart activé (Samuel) → c'est son tiroir qui s'ouvre, pas celui du thème (sinon 2 tiroirs, AMP vide).
        const amp = typeof window.SLIDECART_UPDATE === 'function' && typeof window.SLIDECART_OPEN === 'function';
        const useDrawer = !amp && !!(CartEvt && drawer);
        let deferred = null;

        // 10/10 (bug Patricia, « it just keeps adding more bras… now there are 15 in the cart ») : chaque clic sur
        // ADD TO CART rajoutait le pack entier (3 → 6 → 9 → 12 → 15) quand la cliente revenait sur la buy box au lieu
        // d'aller au paiement. Si exactement ce pack (même palier, mêmes couleurs/tailles) est déjà au panier, on ouvre
        // le panier au lieu de le rajouter. Un autre palier ou d'autres couleurs s'ajoutent comme avant ; la quantité
        // reste modifiable avec + dans le panier. Panier illisible → comportement d'avant (on ajoute).
        try {
          const cur = await (await fetch(rt + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          const deja = new Map();
          (cur.items || []).forEach(it => {
            if (it.properties && it.properties._bundle === b.dataset.title) deja.set(it.variant_id, (deja.get(it.variant_id) || 0) + it.quantity);
          });
          if (items.length && items.every(i => (deja.get(i.id) || 0) >= i.quantity)) {
            console.info('[tw-buybox] pack already in cart → opening the cart instead of adding it again');
            if (amp) { try { await window.SLIDECART_UPDATE(); } catch (e) {} window.SLIDECART_OPEN(); }
            else window.location.href = rt + 'cart';
            atc.removeAttribute('disabled');
            return;
          }
          // 27/10 (Samuel, go 3475 — « ne fais pas attendre le client ») : 13/331 commandes 6+ tanks parties sans
          // cadeau (course : tw-gift.js ajoutait le cadeau ~0,35 s APRÈS le pack ; Australie 30 %). Si ce pack fait
          // passer le panier à 6 tanks ou plus et qu'aucun cadeau n'y est, la ligne « 🎁 Free Mystery Gift » (variante
          // « Mystery surprise », NK-WASH-1PK, 0 $) part DANS LE MÊME add.js que les tanks. Même règle que tw-gift.js
          // (mêmes produits tanks, seuil 6), qui reste en place comme filet (il voit le cadeau déjà là : pas de doublon).
          // Marché FR (/fr-fr, /fr-ch, EUR/CHF) : rien ne change. Aucun délai, aucun blocage : si l'ajout avec le
          // cadeau échoue, on refait l'ajout SANS le cadeau (la vente passe toujours).
          if (!MARCHE_FR_GIFT() && GIFT_TANKS.indexOf(+product.id) !== -1) {
            const avant = (cur.items || []).reduce((n, it) => n + (GIFT_TANKS.indexOf(it.product_id) !== -1 ? it.quantity : 0), 0);
            const ajout = items.reduce((n, i) => n + i.quantity, 0);
            const dejaCadeau = (cur.items || []).some(it => GIFT_ALL.indexOf(it.variant_id) !== -1);
            if (avant + ajout >= 6 && !dejaCadeau) giftLine = { id: GIFT_VARIANT, quantity: 1 };
          }
        } catch (e) { /* lecture du panier impossible : on ajoute comme avant */ }

        if (useDrawer) {
          deferred = CartEvt.createPromise();
          atc.dispatchEvent(new CartEvt({
            action: 'add', context: 'product',
            lines: items.map(i => ({ merchandiseId: String(i.id), quantity: i.quantity })),
            promise: deferred.promise,
          }));
        }

        // Le cadeau part EN PREMIER dans items[] : Shopify affiche le panier du plus récent au plus ancien, il arrive donc SOUS les tanks.
        const addItems = giftLine ? [giftLine].concat(items) : items;
        let r = await fetch(rt + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(useDrawer ? { items: addItems, sections: sectionIds.join(',') } : { items: addItems })
        });
        if (!r.ok && giftLine) {
          // 27/10 : le cadeau ne doit jamais faire échouer l'achat → même ajout sans le cadeau (tw-gift.js le rajoutera).
          console.warn('[tw-buybox] add with gift failed → retry without gift');
          r = await fetch(rt + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(useDrawer ? { items, sections: sectionIds.join(',') } : { items })
          });
        }
        const res = await r.json().catch(() => ({}));
        if (!r.ok) {
          if (deferred) deferred.reject(new Error(res.description || 'Error'));
          throw new Error(res.description || 'Error');
        }

        if (amp) {
          try { await window.SLIDECART_UPDATE(); } catch (e) {}
          window.SLIDECART_OPEN();
          atc.removeAttribute('disabled');
          return;
        }
        if (!useDrawer) { window.location.href = rt + 'cart'; return; }

        const cart = await (await fetch(rt + 'cart.js')).json();
        deferred.resolve({
          cart: CartEvt.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'tw-buybox', itemCount: items.reduce((n, i) => n + i.quantity, 0), sections: res.sections, didError: false },
        });
        atc.removeAttribute('disabled');
      } catch (x) {
        atc.removeAttribute('disabled');
        if (err) { err.hidden = false; err.textContent = x.message; }
      }
    });

    // Barre d'achat collante : visible une fois le bouton principal dépassé.
    const sticky = root.querySelector('[data-tw-sticky]');
    if (sticky && atc) {
      let t = false;
      const upd = () => { sticky.classList.toggle('show', atc.getBoundingClientRect().bottom < 0); t = false; };
      addEventListener('scroll', () => { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
      const sb = sticky.querySelector('[data-tw-sticky-btn]');
      sb && sb.addEventListener('click', e => { e.preventDefault(); root.scrollIntoView({ behavior: 'smooth' }); });
    }
  }

  function initRail(root) {
    const rail = root.querySelector('[data-tw-rail]');
    if (!rail) return;
    const step = () => { const c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 14 : 300; };
    const n = root.querySelector('[data-tw-next]'), p = root.querySelector('[data-tw-prev]');
    n && n.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    p && p.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tw]').forEach(el => {
      if (el.dataset.twReady) return;
      el.dataset.twReady = '1';
      const kind = el.dataset.tw;
      if (kind === 'buybox') { initGallery(el); initBuybox(el); }
      if (kind === 'rail') initRail(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

/* 09/10 (Matteo, 6-reasons-lp en 3+3) : ?pack=6 (ou #pack-6) dans l'URL présélectionne le pack de cette quantité
   dans la buy box, comme si la cliente avait cliqué dessus. Sans paramètre : rien ne change. */
(() => {
  const m = (location.search.match(/[?&]pack=(\d{1,2})(?:&|$)/) || location.hash.match(/^#pack-(\d{1,2})$/) || [])[1];
  if (!m) return;
  const go = () => document.querySelectorAll('[data-tw="buybox"]').forEach(root => {
    const b = root.querySelector(`[data-tw-bundle][data-qty="${m}"]`);
    if (b && !b.classList.contains('on')) b.click();
  });
  const later = () => setTimeout(go, 0);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
})();
